import React from "react";
import { getContractDetails } from "../../action/contract/getContractDetails";
import { getCardsDetails } from "../../action/cardDetails/cards";
import Loader from "../loader/loader";
import { Link } from "react-router-dom";
import { formatMonthDate } from "../../utils/const";
import { connect } from "react-redux";
import HeroSection from "./heroSection";
import ContractList from "./contractList";
import CardDetails from "./cardDetails";
import ContractHistory from "./contractHistory";
import Addcard from "../card/addCard";
import { analyticsClickEvent } from "../../action/firebaseAnalytics/firebaseAnalytics";
import { GTMUserIdAndLoginState } from "../../utils/GtmDatalayer";
import { PropTypes } from 'prop-types';
import { fetchBannerConfiguration, setUserDetails, getUserContext } from '../../utils/helpers/storageUtils';

export class Wallet extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      profilePicture: props.profilePicture,
      contractSummary:props.contractSummary,
      hasActiveContract: [],
      hasActiveCards: [],
      hasContractHistory: [],
      isLoading: false,
      inputValue: "",
      activeTab: 1,
      hasSearch: "",
      modal: false,
      cardHolderName:'',
      reloadFlag: false,
      errors: {
        cardHolderName:''
    },
      UserName: ''
    };
    this.handleSelect = this.handleSelect.bind(this);
  }
  
   async componentDidMount() {

      // Push the customer id and loginState if available on this page to the dataLayer
      window.dataLayer = window.dataLayer || {};
      GTMUserIdAndLoginState();
        this.props.fetchBannerConfiguration();
        this.initialLoad();
        if(sessionStorage.getItem('forwardRoute') === '/wallet'){
          let myCardSection = document.getElementById('myCard-tab')
          myCardSection.click();
        }
        if(sessionStorage.getItem('getScheduleContractDetails')!=null && sessionStorage.getItem('getScheduleContractDetails')!=undefined && sessionStorage.getItem('getScheduleContractDetails')!='' &&  sessionStorage.getItem('getScheduleContractDetails')!='false'){
          window.$("#registerModal").modal("show");

          setTimeout(()=>{
            window.$("#registerModal").modal("hide");
            sessionStorage.setItem('getScheduleContractDetails','')
          },8000)
          
        }
        if (sessionStorage.getItem('isDetailsSet') !== 'true') {
          const userName = await setUserDetails(this.props.setUserName,this.props.setProfilePic);
          this.setState({UserName :userName });
        }

    }

  componentDidUpdate(prevProps) {
    const contractStorageString = sessionStorage.getItem('contractSummary');
    if (contractStorageString) {
      try {
        const parsedSummary = JSON.parse(contractStorageString);
        if (JSON.stringify(prevProps.contractSummary) !== JSON.stringify(parsedSummary)) {
          this.props.getContractSummaryDetails(parsedSummary);
        }
      } catch (e) {
        console.error('Invalid JSON in sessionStorage contractSummary', e);
      }
    }
  }

  initialLoad=async()=>{
    this.setState({ isLoading: true });
    const contractDetails = await getContractDetails({
      ...getUserContext(),
      contract: "",
    });

if(contractDetails !== undefined){
    if (contractDetails.data.statusCode === 200) {
      let hasActiveContractArray = [];
      let hasContractHistoryArray = [];
      contractDetails.data.data.map((response) => {
        if (response.contract_status.includes('Active')) {
          let dataObj = {
            contractId: response.contract_id,
            contractName: response.contract_name,
            contractLoanAmount: response.contract_loan_amount,
            contractBalanceOutStanding: response.contract_balance__c,
            contractNextPayment: formatMonthDate(response.next_payment_date),
            contractReserveAmountforNextDue:response.reserve_amount_for_next_due__c,
            contractAccountCover: response.account_cover,
            contractAccountName: response.account_name,
            contractCompletionDate: response.contract_completion_date,
            contractApsTransactionAmount:response.contract_aps_transaction_amount__c || 0.00,
            contractSellerAccount:response.seller_account__c
          };
          hasActiveContractArray.push(dataObj);
        }
        if (response.contract_status.includes('Closed')) {
          let completedData = {
            contractId: response.contract_id,
            contractName: response.contract_name,
            contractLoanAmount: response.contract_loan_amount,
            contractBalanceOutStanding: response.contract_balance__c,
            contractNextPayment: formatMonthDate(response.next_payment_date),
            contractReserveAmountforNextDue:response.reserve_amount_for_next_due__c,
            contractAccountCover: response.account_cover,
            contractAccountName: response.account_name,
            contractCompletionDate: response.contract_completion_date,
            contractApsTransactionAmount:response.contract_aps_transaction_amount__c || 0.00,
            contractSellerAccount:response.seller_account__c
          };
          hasContractHistoryArray.push(completedData);
        }
      });

      this.setState({
        hasActiveContract: hasActiveContractArray,
        hasContractHistory: hasContractHistoryArray,
      });
    }
  }
  setTimeout(async() => {
    const contractCardDetails = await getCardsDetails(getUserContext());

    this.getCustomerCardDetails(contractCardDetails);
    
  this.setState({ isLoading: false });
  }, 3000);

  }


  handleSelect = (event,value,firebaseEvent) => {
    event.preventDefault();
    analyticsClickEvent(firebaseEvent,'')
    this.setState({ activeTab: value,hasActiveCards:[] });
    this.initialLoad();
}


  handleSearchValue = (event) => {
    // analyticsTypeEvent('history_search')
    this.setState({ inputValue: event.target.value });

    const activeTabId = this.state.activeTab;
    let filterDetails;
    switch (activeTabId) {
      case 1:
        filterDetails = this.state.hasActiveContract.filter(
          (activeContract) => {
          
            return activeContract.contractAccountName
              .toLowerCase()
              .includes(this.state.inputValue.toLocaleLowerCase());
          }
        );

        break;
      case 2:
        filterDetails = this.state.hasContractHistory.filter(
          (contractHistory) => {
            return contractHistory.contractAccountName
              .toLowerCase()
              .includes(this.state.inputValue.toLocaleLowerCase());
          }
        );

        break;
    }

    this.setState({ hasSearch: filterDetails });
  };

  onShowAddCard = () => {
     analyticsClickEvent('payment_authority_ok','')
    setTimeout(() => {
      this.setState((prevState)=>{
        return{
          errors: {
            ...prevState.errors,
            cardHolderName: ''
          }
        }
      })
      window.$("#addCard").modal("show");
      window.$(".add-card-form").trigger('reset');
      this.setState({cardHolderName:'',});
    }, 1000);

  };

  paymentfunctionCall=()=>{
    // window.location.reload(false)
    window.$("#addCard").modal("hide");
    
    setTimeout(() => {
      if(sessionStorage.getItem('cardMessage') !== '' && sessionStorage.getItem('cardMessage') !== null){
        this.setState({reloadFlag: true})
        window.$("#addCardModal").modal("show");
      }
    }, 1000);

    setTimeout(() => {
      window.$("#addCardModal").modal("hide");
      sessionStorage.removeItem('cardMessage');
      this.setState({ isLoading: true,hasActiveCards:[] });
      if(this.state.reloadFlag){
        window.location.reload(false);
      }
    }, 4000);

    setTimeout(async() => {
    this.initialLoad();
    }, 6000);
    
  }

  getCustomerCardDetails = (contractCardDetails) => {
    if(contractCardDetails !== undefined){
      if (contractCardDetails.data.statusCode === 200) {
        let hasActiveCardsArray = [];
        contractCardDetails.data.data.map((response) => {
            let dataObj = {
              cardId: response.hummuk_customer_card_detail_id,
              cardNumber: response.hummuk_customer_card_detail_card_number__c,
              cardExpiryMonth: response.hummuk_customer_card_detail_exp_month,
              cardExpiryYear: response.hummuk_customer_card_detail_exp_year,
              PaymentMethodId: response.hummuk_customer_card_detail_payment_method_id__c,
              cardHoldName: response.hummuk_customer_card_detail_card_holder_name__c,
              cardStatus: response.hummuk_customer_card_detail_primary_card__c,
              cardType:response.hummuk_customer_card_detail_card_type__c.toLowerCase()
          
              // contractCompletionDate:response.contract_end_date
            };
          hasActiveCardsArray.push(dataObj);
        });
  
        this.setState({ hasActiveCards: hasActiveCardsArray });
      }
    }
  }


  changeModalStatus(e) {
     analyticsClickEvent('add_card','')
    this.setState({ modal: false });
  }

  onlyAcceptInputs = (e) => {
      if (!/[a-z ]/i.test(e.clipboardData.getData('Text')) || /\d/.test(e.clipboardData.getData('Text')) || /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/.test(e.clipboardData.getData('Text'))) {
        e.preventDefault();
      }
    
  }
  handleKeyDown = event => {
    if (event.key === 'Enter') {
             event.preventDefault()
    }
}
  
  analyticscclickEvent(){
    analyticsClickEvent('wallet_apply_now','');
  }

  handleChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
  //  analyticsTypeEvent(name)

    let cardHolderName = '';
   

    if(name == 'cardHolderName'){
        if (value.trim() === "") {
          cardHolderName = `Cardholder name is required`;
        } else if (!/^[A-Za-z '-]+$/.test(value)) {
          cardHolderName = "Invalid characters";
        } else {
          cardHolderName = '';
        }
    }
    else {
      cardHolderName = '';
    }
    this.setState((prevState) => {
      return {
        errors: { ...prevState.errors, cardHolderName: cardHolderName },
        [name]: value
      }
    })
}

cardHolderCheckvalidation = () => {
  setTimeout(() => {
   
    if(this.state.cardHolderName == ''){
      this.setState((prevState) => {
        return {
          errors: {
            ...prevState.errors,
            cardHolderName: 'Cardholder name is required'
          }
        }
      })
    }
  }, 100);
  
}

// FCA-1250 - Hiding virtual card reference in the app as it is not required for now.

  

  render() {
    return (  
      <div className="wrapper wallet-wrapper">
        <Loader loaderStatus={this.state.isLoading} />
        <section className="main">
          <HeroSection profilePicture={this.props.profilePicture} contractSummary={this.props.contractSummary} userName={this.state.UserName} />
        </section>
        <section className="contract--item">
          <div className="container">
            <div className="d-flex wallet-contract">
              <div className="nav-tabs">
                <ul className="nav nav-tabs" id="myTab" role="tablist">
                  <li className="nav-item">
                    <a
                      className="nav-link active"
                      id="activeCont-tab"
                      data-toggle="tab"
                      href="#activeCont"
                      role="tab"
                      aria-controls="home"
                      aria-selected="true"
                      onClick={(event) => this.handleSelect(event,1,'active_contracts_menu')}
                    >
                      Active Contracts
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      id="contractHis-tab"
                      data-toggle="tab"
                      href="#contractHis"
                      role="tab"
                      aria-controls="contractHis"
                      aria-selected="false"
                      onClick={(event) => this.handleSelect(event,2,'history_menu')}
                    >
                      Contract History
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      id="myCard-tab"
                      data-toggle="tab"
                      href="#myCard"
                      role="tab"
                      aria-controls="myCard"
                      aria-selected="false"
                      onClick={(event) => this.handleSelect(event,3,'mycards_menu')}
                    >
                         {this.state.hasActiveCards?'My Cards':'My Card'}
                     
                    </a>
                  </li>
                </ul>
              </div>
              {this.state.activeTab <= 2 && (
                <div className="search--item">
                  <div className="search-bar">
                    <input
                      className="form-control"
                      type="text"
                      id="search"
                      value={this.state.inputValue}
                      name="search"
                      onChange={this.handleSearchValue}
                      placeholder="Search"
                      onBlur ={(e) => analyticsClickEvent('wallet_search',this.state.inputValue)}
                      onClick={(e) => analyticsClickEvent('wallet_search','')}
                    />
                  </div>
                </div>
              )}

              {this.state.activeTab === 3 &&  this.state.hasActiveCards.length!==0 &&(
                <div className="addCardBtn--item">
                  <div className="addCard-button">
                    <button
                      className="add-card-bth"
                      type="button"
                      data-toggle="modal"
                      data-target="#commonModel"
                      onClick={(e) => this.changeModalStatus(e)}
                    >
                      Add Card
                    </button>
                  </div>
                </div>
              )}
            </div>
            <div className="tabs-section">
              <div className="tab-content" id="myTabContent">
                <div
                  className="tab-pane fade show active"
                  id="activeCont"
                  role="tabpanel"
                  aria-labelledby="activeCont-tab"
                >
                  <div className="contract-list">
                    <div className="row">
                      {this.state.hasActiveContract.length === 0 && (
                        <div className="col-lg-6 col-md-6 col-12 left-card--item">
                          <div className="card">
                            <div className="card-body">
                              <div className="my-card--content">
                                <p>
                                  You do not have any active contract at the
                                  moment. Apply right now by clicking below.
                                </p>
                              </div>
                            </div>
                            <div className="card-footer">
                              {/* <button className="add-card-bth"  to="\application"type="button">Apply Now</button> */}
                              <Link
                                className="add-card-bth"
                                to="/application"
                                onClick={this.analyticscclickEvent}
                              >
                                Apply Now
                              </Link>
                            </div>
                          </div>
                        </div>
                      )}

                      {this.state.hasActiveContract && (
                        <ContractList
                          //items={this.state.hasActiveContract}
                          items={
                            this.state.inputValue && this.state.activeTab === 1
                              ? this.state.hasSearch
                              : this.state.hasActiveContract
                          }
                        />
                      )}
                    </div>
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="contractHis"
                  role="tabpanel"
                  aria-labelledby="contractHis-tab"
                >
                  <div className="contract-list">
                    <div className="row">
                      {this.state.hasContractHistory.length === 0 && (
                        <div className="col-lg-6 col-md-6 col-12 left-card--item">
                          <div className="card">
                            <div className="card-body">
                              <div className="my-card--content">
                                <p>
                                No Contract History Found.
                                </p>
                              </div>
                            </div>
                            <div className="card-footer">                              
                            </div>
                          </div>
                        </div>
                      )}
                      {this.state.hasContractHistory && (
                        <ContractHistory
                          //items={this.state.hasActiveContract}
                          items={
                            this.state.inputValue && this.state.activeTab === 2
                              ? this.state.hasSearch
                              : this.state.hasContractHistory
                          }
                        />
                      )}
                    </div>
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="myCard"
                  role="tabpanel"
                  aria-labelledby="myCard-tab"
                >
                  <div className="my-card--item">
                    {this.state.hasActiveCards.length === 0 && (
                      <div className="row no-card-item">
                        <div className="col-lg-6 col-md-6 col-12 left-card--item">
                          <div className="card">
                            <div className="card-body">
                              <div className="my-card--content">
                                <p>
                                  You do not have any active cards at the
                                  moment. Please add one by clicking below.
                                </p>
                              </div>
                            </div>
                            <div className="card-footer">
                              <button
                                className="add-card-bth"
                                type="button"
                                data-toggle="modal"
                                data-target="#commonModel"
                              >
                                Add Card
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    <div className="card-active">
                      {this.state.hasActiveCards.length !== 0 && (
                             <CardDetails items={this.state.hasActiveCards}  paymentfunctionCalls={this.paymentfunctionCall}/>
                      )}
                      {/* FCA-1250 - Hiding virtual card reference in the app as it is not required for now. */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div
          className="modal fade"
          id="addCard"
          tabIndex="-1"
          aria-labelledby="manualPayNextTitle"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered" >
            <div className="modal-content">
              <div className="modal-header">
                <button
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick = {(_e) => analyticsClickEvent('add_card_popup_close','')}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="logo">
                  <img
                    src="images/modal-logo.svg"
                    alt="logo"
                    className="img-fluid"
                  />
                </div>
                <div className="tittle-content">
                  <h2>Add Card</h2>
                </div>
                <form className="add-card-form">
                  <div className="form-group">
                    <input
                      className="form-control"
                      type="text"
                      id="card-holder-name"
                      name="cardHolderName"
                      value={this.state.cardHolderName}
                      placeholder="Cardholder Name"
                      onPaste={(e) => { this.onlyAcceptInputs(e) }}
                      onChange={(e) => this.handleChange(e)}
                      onKeyDown={this.handleKeyDown}
                      onClick = {(e) => analyticsClickEvent('cardholder_name','')}
                    />
                
                     <p className="error-message card-holder-error">
                                        {this.state.errors.cardHolderName !== '' &&
                                            <span>{this.state.errors.cardHolderName}</span>
                                        }</p>
                  </div>
                 
                  {/* <div className="form-group">
                    <input
                      className="form-control"
                      type="text"
                      placeholder="Credit Card Number"
                    />
                  </div>
                  <div className="d-flex">
                    <div className="monthyear">
                      <div className="form-group">
                        <input
                          className="form-control"
                          type="text"
                          placeholder="MM/YY"
                        />
                      </div>
                    </div>
                    <div className="cvv">
                      <div className="form-group">
                        <input
                          className="form-control"
                          type="text"
                          placeholder="CVV"
                        />
                      </div>
                    </div>
                  </div> */}
                </form>
                <Addcard paymentfunctionCalls={this.paymentfunctionCall}  cardHolderCheckvalidation={this.cardHolderCheckvalidation} isValidCardHolder = {this.state.errors.cardHolderName} cardHolderName={this.state.cardHolderName}/> 
              </div>
              {/* <div className="modal-footer">
                <button type="button" className="btn btn-primary">
                  Confirm
                </button>
              </div> */}
            </div>
          </div>
        </div>

        {/* model for notify */}
        <div
          className="modal fade"
          id="notify-virtual-card"
          tabIndex="-1"
          aria-labelledby="notifyVirtualCard"
          aria-hidden="true"
        >
          
          <div className="modal-dialog" >
            <div className="modal-content">
              <div className="modal-header">
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={(_e) => analyticsClickEvent('notifyVirtualCard_popup_close','')}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="logo">
                  <img
                    src="images/modal-logo.svg"
                    alt="logo"
                    className="img-fluid"
                  />
                </div>
                <div className="tittle-content">
                  <p>
                    Kindly login using your mobile application to request a
                    virtual card
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* end model for notify */}

        {/* privacy policy */}
        <div
          className="modal fade model-error"
          id="commonModel"
          tabIndex="-1"
          aria-labelledby="commonModellLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog" >
            <div className="modal-content">
              <div className="modal-header"></div>
              <div className="modal-body">
                <div className="logo">
                  <img
                    src="images/modal-logo.svg"
                    alt="logo"
                    className="img-fluid"
                  />
                </div>
                <h5 className="modal-title " id="commonModellLabel">
                  Payment Authority
                </h5>
                <p className="text-center mt-4">
                  Please confirm you authorise humm to debit the card details
                  you provide for future payments due under this Loan Agreement
                  under a Continuous Payment Authority.
                  <br />
                  <br />
                  Please mark the new card you have added as the primary card for all future repayments.
                </p>
              </div>

              <div className="modal-footer mb-4">
                <button
                  type="button"
                  className="btn btn-primary"
                  data-dismiss="modal"
                  onClick={() => {
                    this.onShowAddCard();
                  }}
                >
                  Ok
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* privacy policy */}
        <div className="modal fade" id="registerModal" tabIndex="-1" aria-labelledby="registerModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
                    <div className="modal-dialog" >
                        <div className="modal-content">
                            <div className="modal-body">
                                <div className="logo">
                                    <img src="images/modal-logo.svg" alt="logo" className="img-fluid" />
                                </div>

                                <p>{sessionStorage.getItem('getScheduleContractDetails')}</p>

                        </div>
                    </div>
                </div>
      </div>

      {/* add Card Message popup */}
      <div
          className="modal fade model-error"
          id="addCardModal"
          tabIndex="-1"
          aria-labelledby="addCardModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog" >
            <div className="modal-content">
              <div className="modal-header"></div>
              <div className="modal-body">
                <div className="logo">
                  <img
                    src="images/modal-logo.svg"
                    alt="logo"
                    className="img-fluid"
                  />
                </div>
                <h5 className="modal-title " id="addCardModalLabel">
                  Message
                </h5>
                {sessionStorage.getItem('cardMessage') !== '' &&
                <p className="text-center mt-4">
                  {sessionStorage.getItem('cardMessage')}
                </p>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export const mapStateToProps = (state) => {
  console.log('state-wallet',state);
  return {
    profilePicture: state.dataStore.profilePicture,
    contractSummary:state.dataStore.contractSummary,
    isBannerEnable: state.dataStore.isBannerEnable,
    userName:state.dataStore.userName
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    getContractSummaryDetails: (summary) => {
      return dispatch({
        type: 'SET_CONTRACT_SUMMARY',
        value: summary
      });
    },
    setUserName: (value) => {
      return dispatch({
        type: 'SET_USERNAME',
        value: value
      })
    },
    setProfilePic: (userPic) => {
      return dispatch({
        type: 'SET_PROFILE_PIC',
        value: userPic
      });
    },
    fetchBannerConfiguration: () => {
      return dispatch(fetchBannerConfiguration());
    }
  }
}

Wallet.propTypes = {
  profilePicture: PropTypes.string,
  contractSummary: PropTypes.string,
}

export default connect(mapStateToProps, mapDispatchToProps)(Wallet);
